import type { ExportedUser } from '../api/models/admin.model';

export const USERS_CSV_HEADERS: [keyof ExportedUser, string][] = [
	['firstName', 'First Name'],
	['lastName', 'Last Name'],
	['username', 'Username'],
	['emailAddress', 'Email Address'],
	['creationDate', 'Creation Date'],
	['lastLoginDate', 'Last Login Date'],
	['restrictInvoices', 'Restrict Invoices'],
	['phoneNumber', 'Phone Number'],
	['phoneType', 'Phone Type'],
	['userStatus', 'User Status'],
	['passwordStatus', 'Password Status'],
	['accountStatus', 'Account Status'],
	['roleName', 'Role Name'],
	['roleType', 'Role Type'],
	['accountName', 'Account Name'],
];

// Column order and labels for the "Invoice Details" CSV export on the Invoice
// Details page's Assets grid (Bug #2724206). Keys map to fields on the flattened
// export row assembled in DataGridToolbarActionsComponent.
export const INVOICE_ASSET_EXPORT_CSV_HEADERS: [string, string][] = [
	['assetNumber', 'Asset Number'],
	['assetQuantity', 'Asset Quantity'],
	['accountName', 'Account Name'],
	['scheduleNo', 'Schedule No'],
	['invoiceNumber', 'Invoice No'],
	['invoiceDate', 'Invoice Date'],
	['invoiceDueDate', 'Invoice Due Date'],
	['purchaseOrderNo', 'Purchase Order No'],
	['invoiceDescription', 'Invoice Description'],
	['invoiceAmount', 'Invoice Amount'],
	['taxAmount', 'Tax Amount'],
	['totalInvoiceAmount', 'Total Invoice Amount'],
	['assetCategory', 'Asset Category'],
	['manufacturer', 'Manufacturer'],
	['modelNumber', 'Model Number'],
	['itemDescription', 'Item Description'],
	['eqLocationAddress1', 'Eq. Location Address 1'],
	['eqLocationAddress2', 'Eq. Location Address 2'],
	['eqLocationAddress3', 'Eq. Location Address 3'],
	['eqLocationCity', 'Eq. Location City'],
	['eqLocationState', 'Eq. Location State'],
	['eqLocationZipCode', 'Eq. Location Zip Code'],
	['eqLocationCounty', 'Eq. Location County'],
	['invoiceBillingAddress1', 'Invoice Billing Address 1'],
	['invoiceBillingAddress2', 'Invoice Billing Address 2'],
	['invoiceBillingAddress3', 'Invoice Billing Address 3'],
	['invoiceBillingCity', 'Invoice Billing City'],
	['invoiceBillingState', 'Invoice Billing State'],
	['invoiceBillingPostalCode', 'Invoice Billing Postal Code'],
	['invoiceBillingCounty', 'Invoice Billing County'],
	['invoicePastDue', 'Invoice Past Due'],
	['barcode', 'Barcode'],
	['glCode', 'GL Code (UDF)'],
	['udf1', 'UDF1'],
	['udf2', 'UDF2'],
	['udf3', 'UDF3'],
	['udf4', 'UDF4'],
];

// Server page size when walking every page of the invoice-asset endpoint to
// build the CSV client-side. Sized to cover a large invoice in one round-trip
// while staying comfortably below the backend's request cap.
export const INVOICE_ASSET_EXPORT_PAGE_SIZE = 200;
